module.exports = __webpack_public_path__ + "img/TSGFrischwasser.6762a9e6.png";